// extracted by mini-css-extract-plugin
module.exports = {"NavLink":"NavLinkItem_NavLink__2DU3w","NavLinkActive":"NavLinkItem_NavLinkActive__2jy-Q"};